// Auto-generated by forge/extract-bytecodes.ts — DO NOT EDIT
// Source: forge/out/ReputationRegistry.sol/ReputationRegistry.json

export const REPUTATION_REGISTRY_ABI = [
  {
    "type": "function",
    "name": "getFeedbackCount",
    "inputs": [
      {
        "name": "agentId",
        "type": "uint256",
        "internalType": "uint256"
      }
    ],
    "outputs": [
      {
        "name": "",
        "type": "uint256",
        "internalType": "uint256"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "getScore",
    "inputs": [
      {
        "name": "agentId",
        "type": "uint256",
        "internalType": "uint256"
      }
    ],
    "outputs": [
      {
        "name": "",
        "type": "uint256",
        "internalType": "uint256"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "getTier",
    "inputs": [
      {
        "name": "agentId",
        "type": "uint256",
        "internalType": "uint256"
      }
    ],
    "outputs": [
      {
        "name": "tier",
        "type": "uint256",
        "internalType": "uint256"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "giveFeedback",
    "inputs": [
      {
        "name": "agentId",
        "type": "uint256",
        "internalType": "uint256"
      },
      {
        "name": "scoreDelta",
        "type": "uint256",
        "internalType": "uint256"
      },
      {
        "name": "tags",
        "type": "string[]",
        "internalType": "string[]"
      },
      {
        "name": "comment",
        "type": "string",
        "internalType": "string"
      }
    ],
    "outputs": [],
    "stateMutability": "nonpayable"
  },
  {
    "type": "function",
    "name": "setScore",
    "inputs": [
      {
        "name": "agentId",
        "type": "uint256",
        "internalType": "uint256"
      },
      {
        "name": "score",
        "type": "uint256",
        "internalType": "uint256"
      }
    ],
    "outputs": [],
    "stateMutability": "nonpayable"
  },
  {
    "type": "event",
    "name": "FeedbackGiven",
    "inputs": [
      {
        "name": "agentId",
        "type": "uint256",
        "indexed": true,
        "internalType": "uint256"
      },
      {
        "name": "from",
        "type": "address",
        "indexed": true,
        "internalType": "address"
      },
      {
        "name": "scoreDelta",
        "type": "uint256",
        "indexed": false,
        "internalType": "uint256"
      }
    ],
    "anonymous": false
  },
  {
    "type": "event",
    "name": "ScoreUpdated",
    "inputs": [
      {
        "name": "agentId",
        "type": "uint256",
        "indexed": true,
        "internalType": "uint256"
      },
      {
        "name": "newScore",
        "type": "uint256",
        "indexed": false,
        "internalType": "uint256"
      }
    ],
    "anonymous": false
  }
] as const;

export const REPUTATION_REGISTRY_BYTECODE = "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" as const;
